export enum ControlTowerCardStatus {
  LIVE = 'live',
  READY = 'ready',
  PREGENERATING = 'pregenerating',
  DELAYED = 'delayed',
  STUCK = 'stuck',
  ERROR = 'error',
  NOT_STARTED = 'not_started'
}
